import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PublicContainer } from '@/containers/PublicContainer';
import { Preloader } from '@/components/Preloader';
import { RoundLink } from '@/components/UI/RoundLink';
import { APP_LINKS } from '@/helpers/links';
import { useUserStore } from '@/store/userStore';
import { verifyUserEmail } from '@/store/services/userServices';
import IconSuccess from '../../assets/icons/icon_success_122.svg';
import IconFailed from '../../assets/icons/icon_failed_122.svg';
import s from './index.module.scss';

const ERROR_CODES = {
  email_verification_code_must_be_uuid: 'email_verification_code_must_be_uuid',
  email_verification_not_found: 'email_verification_not_found',
  email_verification_has_expired: 'email_verification_has_expired',
  email_verification_already_verified: 'email_verification_already_verified',
};

const EmailVerificationStatusPage = () => {
  const { code } = useParams();
  const { accessToken } = useUserStore(state => state);
  const [state, setState] = useState({
    loading: true,
    error_code: null,
    message: null,
  });

  useEffect(() => {
    checkVerificationCode(code);
  }, [code]);

  const checkVerificationCode = async code => {
    setState(prev => ({ ...prev, loading: true }));
    const res = await verifyUserEmail(code);
    if (res?.success) {
      return setState(() => ({
        loading: false,
        error_code: res.error_code,
        message: res.data?.message,
      }));
    }
    setState(prev => ({
      ...prev,
      message: res?.message,
      error_code: res.error_code,
      loading: false,
    }));
  };

  const { error_code, loading, message } = state;

  const successIcon =
    error_code === ERROR_CODES.email_verification_already_verified ||
    error_code === null;

  return (
    <PublicContainer>
      <div className="container">
        {loading ? (
          <Preloader className={s.preloader} />
        ) : (
          <div className={s.content}>
            <img
              src={successIcon ? IconSuccess : IconFailed}
              className={s.icon}
              alt="icon"
            />
            <h2 className="f-32 f-500">{message}</h2>
            <RoundLink
              path={accessToken ? APP_LINKS.dashboard : APP_LINKS.auth}
              fillBackground
              className={s.link}
              label={accessToken ? 'Go to Dashboard' : 'Sign in'}
            />
          </div>
        )}
      </div>
    </PublicContainer>
  );
};

export default EmailVerificationStatusPage;
